import { Grid } from "@mui/material"
import { Heading1 } from "../../Components/atoms/Typography/Heading/Heading"
import { Text } from "../../Components/atoms/Typography/Text/Text"

//TODO: This page is only for demonstration purpose. this will removed in the future
export const DummyPageDoctorportalResetPassword = () => {
    return (<>
        <Grid container direction={'column'} width={'100%'} height={'100%'} padding={'10px'} alignItems={'center'} justifyContent={'center'}>
            <Grid item><Heading1 text={'Welcome doctore'} /></Grid>
            <Grid item><Text text={'This is a Tempory page.This will be replaced with doctors portal Reset password Page.'} /></Grid>
        </Grid>
    </>)
}